<div class="replays-modal">
  <h2 md-dialog-title>Multicams related to this Sporting Event Id : {{spevId}}</h2>
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <table *ngIf="!loading">
      <thead>
        <tr>
          <th>Date</th>
          <th>Sport</th>
          <th>Title</th>
          <th>Channel</th>
          <th>Sporting Event Id</th>
          <th>Cam Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let programArticle of programArticles">
          <td>{{programArticle.startDate | date: 'dd/MM/yyyy HH:mm'}} - {{programArticle.endDate | date: 'HH:mm'}}</td>
          <td> {{programArticle.sport.value}} </td>
          <td>
            <div *ngIf="programArticle.destinations[0] && programArticle.destinations[0].value.translations[0]">
              {{programArticle.destinations[0].value.translations[0].content | undefinedString}}</div>
          </td>
          <td> {{programArticle.channel.value}} </td>
          <td> {{programArticle.spev.id}} </td>
          <td>
            <a md-icon-button target="_blank"
              [href]="'/program-articles/' + programArticle.valEmiId + '/' + programArticle.channel.id + '/' + programArticle.language.id + '/' + programArticle.cocoonId">
              {{programArticle.getMultiCamType()}} <md-icon>open_in_new</md-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </md-dialog-content>
</div>


// WEBPACK FOOTER //
// ./src/app/modals/multicams-modal/multicams-modal.component.html